import { Injectable } from '@angular/core';

import {ApiStore, DBDoc, SearchType, SuperType} from '@fry/lib/store';
import {APIService} from "@fry/lib/api";

import { Venue } from './venue';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class VenuesStore extends ApiStore<Venue> {
  AssociatedModel = Venue;

  docType = 'venue';
  endpoint = 'venues';
  superType = SuperType.Org;
  searchType = SearchType.REMOTE;

  constructor(api: APIService) {
    super(api);
  }

  public blank(defaults?: Partial<DBDoc>) {
    const doc = this.prepareBlank(defaults);
    return this.createObject(doc);
  };

  allStub(): Observable<{id: string; name: string}[]>  {
    return this.api.get(`${this.endpoint}/stub`);
  }

}
